import { render, staticRenderFns } from "./ProjectFormModal.vue?vue&type=template&id=331f1022"
import script from "./ProjectFormModal.vue?vue&type=script&lang=js"
export * from "./ProjectFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports